import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {CheckIcon} from '../icon';

import styles from './circle-number.module.css';

type Props = {
    count: number;
    state: 'initial' | 'selected' | 'past';
};

export function CircleNumber(props: Props) {
    const styleName = classnames({
        [styles.circle]: true,
        [styles['circle-selected']]: props.state === 'selected',
        [styles['circle-filled']]: props.state === 'past',
    });

    return (
        <div className={styleName}>
            {props.state === 'past' ? (
                <CheckIcon style={{color: colors.offWhite}} size={16} />
            ) : (
                props.count
            )}
        </div>
    );
}
